export default {
      id: "bank-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#bank",
      toString: function () {
        return this.url;
      }
    }